export default __webpack_public_path__ + "static/media/Gabriele Nicolosi.a3ec2151.jpeg";